<template>
    <div class="custom_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Team Store</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Custom Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">1</div>
                                <h5 class="mb-0">Basic Information</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">2</div>
                                <h5 class="mb-0">Select Product</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">3</div>
                                <h5 class="mb-0">Design</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">4</div>
                                <h5 class="mb-0">Shipping</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field in_active d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">5</div>
                                <h5 class="mb-0">Publish</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="basic_information pb_58">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="heading1 m-0">Create Custom Store</h1>
                        <h5 class="heading5 please_fill mb_12">
                            Please fill the below information to create custom
                            store
                        </h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 accordian_with_form">
                        <div class="accordion mt_36" id="accordionExample">
                            <div class="card">
                                <div class="card-header p-0" id="headingOne">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex store_info_head_accordion"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        Store Information
                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="/maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="/maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseOne"
                                    class="collapse show"
                                    aria-labelledby="headingOne"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body store_info_head_accordion_body"
                                    >
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div
                                                    class="form-group store_custom_margin_left"
                                                >
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Enter here"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Name</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Name"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Store Code</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="row mt_48 start_end_date_row"
                                        >
                                            <div class="col-md-6">
                                                <div
                                                    class="form-group store_custom_margin_left"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form-control docs-date bg-transparent"
                                                        name="date"
                                                        placeholder="Select Date"
                                                        autocomplete="off"
                                                        id="datepicker"
                                                    />
                                                    <label>Start Date</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <div
                                                        class="alert-icon pb_6"
                                                    >
                                                        <img
                                                            src="/maincss/images/datepicker.svg"
                                                            alt=" "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        class="form-control docs-date bg-transparent"
                                                        name="date"
                                                        placeholder="Select Date"
                                                        autocomplete="off"
                                                        id="datepicker2"
                                                    />
                                                    <label>End Date</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <div
                                                        class="alert-icon pb_6"
                                                    >
                                                        <img
                                                            src="/maincss/images/datepicker.svg"
                                                            alt=" "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt_30">
                                <div class="card-header p-0" id="headingTwo">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex"
                                        data-toggle="collapse"
                                        data-target="#collapseTwo"
                                        aria-expanded="true"
                                        aria-controls="collapseTwo"
                                    >
                                        Add Logo & Cover<span
                                            class="ml-auto my-auto minus"
                                            ><img
                                                src="/maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="/maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseTwo"
                                    class="collapse show"
                                    aria-labelledby="headingTwo"
                                    data-parent="#accordionExample"
                                >
                                    <div class="card-body add_logo_and_c_body">
                                        <div class="row">
                                            <div
                                                class="col-md-6 col-lg-6 col-xl-6"
                                            >
                                                <div
                                                    class="form-check pl-0 logo_upload_left_box"
                                                >
                                                    <p
                                                        class="font_size_18 mb_10"
                                                    >
                                                        Logo
                                                    </p>
                                                    <div
                                                        class="brand_logo_select position-relative"
                                                    >
                                                        <img
                                                            src="/maincss/images/create_brand_logo.png"
                                                            alt=""
                                                        />
                                                        <div
                                                            class="delete_brand"
                                                        >
                                                            <a href="#"
                                                                ><img
                                                                    src="/maincss/images/delete_brand.svg"
                                                                    alt=" "
                                                            /></a>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="d-flex mt_10 add_cover_image_content"
                                                    >
                                                        <div class="">
                                                            <p
                                                                class="m-0 font_size_14"
                                                            >
                                                                Accepted file
                                                                types
                                                            </p>
                                                            <p
                                                                class="m-0 proximaNova_light font_size_14"
                                                            >
                                                                PNG, JPG, GIF
                                                            </p>
                                                        </div>
                                                        <div class="ml-auto">
                                                            <p
                                                                class="m-0 proximaNova_light font_size_14"
                                                            >
                                                                (Max size. 5 MB)
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6 col-lg-6 col-xl-6"
                                            >
                                                <p class="font_size_18 mb_10">
                                                    Cover Image
                                                </p>
                                                <div
                                                    class="brand_logo_select cover_img_upload_right_box dashed_border d-flex flex-column position-relative"
                                                >
                                                    <input
                                                        type="file"
                                                        class="brand_logo_upload"
                                                    />
                                                    <img
                                                        src="/maincss/images/cover_image_upload.svg"
                                                        alt=" "
                                                    />
                                                    <p
                                                        class="font_size_14 cover_img_upload mt_18 mb-0"
                                                    >
                                                        Drag & Drop or <br />
                                                        <span
                                                            class="text_primary_blue"
                                                            >Browse</span
                                                        >
                                                        Your Computer
                                                    </p>
                                                </div>
                                                <div
                                                    class="d-flex mt_10 add_cover_image_content"
                                                >
                                                    <div class="">
                                                        <p
                                                            class="m-0 font_size_14"
                                                        >
                                                            Accepted file types
                                                        </p>
                                                        <p
                                                            class="m-0 proximaNova_light font_size_14"
                                                        >
                                                            PNG, JPG, GIF
                                                        </p>
                                                    </div>
                                                    <div class="ml-auto">
                                                        <p
                                                            class="m-0 proximaNova_light font_size_14"
                                                        >
                                                            (Max size. 10 MB)
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt_30">
                                <div class="card-header p-0" id="headingThree">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex add_more_info_head"
                                        data-toggle="collapse"
                                        data-target="#collapseThree"
                                        aria-expanded="true"
                                        aria-controls="collapseThree"
                                    >
                                        Add More Information
                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="/maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="/maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseThree"
                                    class="collapse show"
                                    aria-labelledby="headingThree"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body add_more_info_head_body"
                                    >
                                        <div class="row">
                                            <div
                                                class="col-md-12 col-lg-12 col-xl-12"
                                            >
                                                <div
                                                    class="form-group des_textarea"
                                                >
                                                    <label>Descriptions</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <textarea
                                                        class="form-control bg-transparent"
                                                    >
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, </textarea
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="buttons mt_50 ml-auto text-right">
                            <a
                                href="/team/create-team-store"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                                >BACK</a
                            >
                            <a
                                href="/team/select-product"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                >Next</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "CustomStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("");
        /* eslint-disable */
        $(function () {
            $("#datepicker").datepicker();
            $("#datepicker2").datepicker();
        });
        /* eslint-enable */
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
<style>
.des_textarea textarea {
    resize: none;
}
</style>
